import React from "react";
import { Header } from "../header";
import Visibility from "../utils/Visibility";
import { indexStore } from "../../store/indexStore";
import { IMG_URl } from "../../common/img_url";
import { BranchTabs } from "../Tabs/BranchTabs";
import { useNavigate } from "react-router-dom";
import Iterator from "../utils/Iterator";
import { Skeleton } from "../ui/skeleton";
import MenusElemnts from "../MenusElements/MenusElemnts";
import { useTranslation } from "react-i18next";
import BranchModel from "../../Models/BranchModel";

function SelfBranchScreen() {
  const { menus, branch, restaurant, social, loading, description } =
    indexStore();
  const naivgate = useNavigate();
  const onClickMenu = (id: number | string) => {
    naivgate(`${id}`);
  };
  const descriptionKey: keyof BranchModel =
    description === "description_ar" ? "description_ar" : "description_en";
  const formattedDescription = (branch?.[descriptionKey] ?? "").replace(
    /\n/g,
    "<br/>"
  );
  const { t } = useTranslation();

  return (
    <>
      <Visibility visible={!loading}>
        <Header noBack={true} backgroundColorfull />
        <div className="min-h-screen flex flex-col gap-4 items-center  py-6">
          <div className="px-4 flex flex-col gap-4 justify-center items-center">
            <div className="w-36 h-36 p-4 rounded-xl shadow-lg transition-transform hover:scale-105">
              <img
                className="w-full h-full object-cover rounded-md"
                src={`${IMG_URl}${restaurant.logo}`}
                alt="restaurant logo"
              />
            </div>

            <h6
              className="leading-relaxed text-base font-medium"
              dangerouslySetInnerHTML={{ __html: formattedDescription }}
            ></h6>
          </div>

          <div className="flex flex-col gap-4 bg-primary bg-opacity-70 flex-grow rounded-t-[2rem] text-onPrimary p-4 shadow-inner w-full">
            <h2 className="text-lg font-semibold text-center">
              {t("gloabl.menus")}
            </h2>
            <MenusElemnts data={menus} onClickMenu={onClickMenu} />
          </div>
        </div>
      </Visibility>
      <Visibility visible={loading}>
        <RenderLoading />
      </Visibility>
    </>
  );
}

export default SelfBranchScreen;

const RenderLoading = () => {
  return (
    <>
      <Header noBack={true} />
      <div className=" flex  flex-col gap-8  ">
        <div className="flex flex-col gap-4 justify-center items-center  ">
          <Skeleton className="w-36 aspect-square" />
          <div className="flex flex-col gap-4">
            <Skeleton className={"w-36 h-6"} />
            <Skeleton className={"w-36 h-6"} />
          </div>
        </div>

        <Skeleton className="flex-1 flex-col flex gap-4 bg-opacity-70 rounded-t-[2rem] px-4 pt-4 pb-44">
          <div className="flex items-center justify-center">
            <Skeleton className={"w-24 h-6"} />
          </div>

          <div className={`grid grid-cols-3  md:grid-cols-3 gap-5 `}>
            <Iterator
              data={[1, 2, 3, 4, 5, 6]}
              render={() => (
                <div>
                  <Skeleton className={` w-full h-28 rounded-lg  `} />
                </div>
              )}
            />
          </div>
        </Skeleton>
      </div>
    </>
  );
};
